import { DateFormat } from "@archetypes/form";
import { format } from "date-fns";
import { TZDateMini } from "@date-fns/tz";

export const shortWeekDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"] as const;
export const shortMonths = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
] as const;

export const getDateFormatLabel = (format: DateFormat) => {
  switch (format) {
    case DateFormat.dayMonthYear:
      return "DD/MM/YYYY";
    case DateFormat.monthDayYear:
      return "MM/DD/YYYY";
    case DateFormat.yearMonthDay:
      return "YYYY/MM/DD";
  }
};

/**
 * Returns UTC offset string (e.g. "+05:30", "-04:00") extracted from tzString
 * If tzString is missing or invalid, uses system timezone offset.
 * Works in both Node.js and browser.
 * @param {string} [tzString] - e.g. "(UTC+10:00) Canberra, Melbourne, Sydney"
 * @returns {string} e.g. "+05:30" or "-04:00"
 */
export function getUTCOffsetString(tzString?: string) {
  let offset: string | undefined = undefined;

  if (tzString && typeof tzString === "string") {
    const match = tzString.match(/UTC\s*([+-]\d{1,2})(?::?(\d{2}))?/i);
    if (match) {
      const hours = match[1].padStart(3, match[1].startsWith("-") ? "-" : "+");
      const minutes = match[2] ? `:${match[2]}` : ":00";
      offset = `${hours}${minutes}`;
    }
  }

  // If tzString not given or invalid → fallback to system timezone offset
  if (!offset) {
    const minutes = -new Date().getTimezoneOffset(); // note: JS gives negative for positive offsets
    const sign = minutes >= 0 ? "+" : "-";
    const abs = Math.abs(minutes);
    const hh = String(Math.floor(abs / 60)).padStart(2, "0");
    const mm = String(abs % 60).padStart(2, "0");
    offset = `${sign}${hh}:${mm}`;
  }

  return offset;
}

export function formatViaTZDate(date: string, offset: string, pattern = DateFormat.dayMonthYear) {
  const dateObj = new TZDateMini(date, offset);
  return format(dateObj, pattern);
}
